import type {TFunction} from 'i18next';
import type {MapCoordinates} from './map';
import type {Media} from './media';
import type {NewsCardView} from './news';
import type {WireSectionBase} from './sections';

export enum UnitSpecKey {
  Bedrooms = 'bedrooms',
  Bathrooms = 'bathrooms',
  Area = 'area',
  DesignCategory = 'property_type',
}

export interface UnitSpecView {
  key: UnitSpecKey;
  value: string;
}

export function specChipLabel(t: TFunction, spec: UnitSpecView): string {
  if (spec.key === UnitSpecKey.Bedrooms) {
    return t('n_beds', {numberOfbeds: spec.value});
  }
  if (spec.key === UnitSpecKey.Bathrooms) {
    return t('n_baths', {numberOfbaths: spec.value});
  }
  if (spec.key === UnitSpecKey.Area) {
    return t('n_area', {area: spec.value});
  }
  return spec.value;
}

export interface UnitTypeCardView {
  uuid: string;
  title: string;
  image: Media;
  contextLabel: string;
  soldOut: boolean;
  specs: UnitSpecView[];
  designCategoryId?: string;
}

export interface UnitTypeDetailView {
  uuid: string;
  projectUuid: string;
  name: string;
  imageUrl?: string;
  contextLabel: string;
  location: string;
  gallery: Media[];
  floorPlans: Media[];
  soldOut: boolean;
  description?: string;
  specs: UnitSpecView[];
  brochureUrl?: string;
  tourUrl?: string;
  amenities: {icon: string; label: string}[];
  masterplan?: Media;
  nearbyImage?: Media;
  linkLocation?: string;
  nearbyCoordinates?: MapCoordinates;
  nearby: {icon?: string; label: string; minutes: number; mapsUrl?: string}[];
  startingPrice?: number;
  designCategory?: WireSectionBase;
}

export interface UnitTypeDetailPageData {
  unit: UnitTypeDetailView;
  latestNews: NewsCardView[];
}
